<template>
  <div class="logs">
    <log-virtual v-for="log in logs" :key="log.sequence" :log="log"/>
  </div>
</template>

<script>
  import LogVirtual from "./log/log-virtual";

  export default {
    name: "logs",
    props: ["data"],
    components: {LogVirtual},
    computed: {
      logs() {
        return this.data.map(node => {
          if (node.items.length > 1) {
            node.items = node.items.filter(item => item.state !== -3);
          }
          return node;
        })
      }
    }
  }
</script>

<style scoped lang="scss">

  @import "../../../assets/css/global";

  .logs {
    background-color: $color-bg;
    padding: 10px 0;
  }
</style>
